import React from 'react';
import { Thermometer, Sun, Cloud, CloudRain, CloudSnow, CloudLightning, CloudFog, Droplets, Wind, Gauge, Eye } from 'lucide-react';

const getWeatherIcon = (condition) => {
  switch (condition) {
    case 'Clear':
      return <Sun size={30} style={{ color: '#FFB800' }} />;
    case 'Clouds':
      return <Cloud size={30} style={{ color: '#90A4AE' }} />;
    case 'Rain':
    case 'Drizzle':
      return <CloudRain size={30} style={{ color: '#4A9EDE' }} />;
    case 'Snow':
      return <CloudSnow size={30} style={{ color: '#B0E0E6' }} />;
    case 'Thunderstorm':
      return <CloudLightning size={30} style={{ color: '#6c5ce7' }} />;
    case 'Mist':
    case 'Fog':
    case 'Haze':
      return <CloudFog size={30} style={{ color: '#B0BEC5' }} />;
    default:
      return <Sun size={30} style={{ color: '#FFB800' }} />;
  }
};

const WeatherWidget = ({ weather }) => {

  if (!weather) {
    return (
      <div className="pub-cus-des-weather-widget p-3">
        <p className="mb-3 d-flex align-items-center gap-2" style={{ fontSize: '0.88rem', fontWeight: 700, color: '#1B4965' }}>
          <Thermometer size={16} style={{ color: '#e74c3c' }} />
          Current Weather
        </p>
        <p style={{ fontSize: '0.85rem', color: '#6c757d' }}>Weather data not available .</p>
      </div>
    );
  }

  return (
    <div className="pub-cus-des-weather-widget p-3">
      <p className="mb-3 d-flex align-items-center gap-2" style={{ fontSize: '0.88rem', fontWeight: 700, color: '#1B4965' }}>
        <Thermometer size={16} style={{ color: '#e74c3c' }} />
        Current Weather
      </p>

      <div className="pub-cus-des-weather-main">
        <div className="pub-cus-des-weather-icon">
          {getWeatherIcon(weather.condition)}
        </div>
        <div>
          <div className="pub-cus-des-weather-temp">
            {weather.temperature !== null ? `${Math.round(weather.temperature)}°C` : '—'}
          </div>
          <div style={{ fontSize: '0.78rem', color: '#6c757d' }}>
            {weather.feels_like !== null ? `Feels like ${Math.round(weather.feels_like)}°C` : ''}
          </div>
          <div style={{ fontSize: '0.82rem', color: '#4A9E8E', fontWeight: 600, textTransform: 'capitalize' }}>
            {weather.description || weather.condition || '—'}
          </div>
        </div>
      </div>

      <div className="pub-cus-des-weather-details">
        <div className="pub-cus-des-weather-detail-item">
          <span className="label"><Droplets size={13} style={{ color: '#0d6efd' }} /> Humidity</span>
          <span className="val">{weather.humidity !== null ? `${weather.humidity}%` : '—'}</span>
        </div>
        <div className="pub-cus-des-weather-detail-item">
          <span className="label"><Wind size={13} style={{ color: '#198754' }} /> Wind</span>
          <span className="val">{weather.wind !== null ? `${weather.wind} m/s` : '—'}</span>
        </div>
        <div className="pub-cus-des-weather-detail-item">
          <span className="label"><Gauge size={13} style={{ color: '#FFB800' }} /> Pressure</span>
          <span className="val">{weather.pressure !== null ? `${weather.pressure} hPa` : '—'}</span>
        </div>
        <div className="pub-cus-des-weather-detail-item">
          <span className="label"><Eye size={13} style={{ color: '#0dcaf0' }} /> Visibility</span>
          <span className="val">{weather.visibility !== null ? `${weather.visibility} km` : '—'}</span>
        </div>
      </div>
    </div>
  );
};

export default WeatherWidget;